import { dateHelper } from './date-helper';

import { IScheduleOverride } from '../interfaces/i-schedule-override.interface';

export const mapSpecialOpeningTimes = (specialOpeningTime: IScheduleOverride[]): {
  dateRange: string,
  time: string | null,
  isClosed: boolean,
}[] => (specialOpeningTime || [])
  .map(({ dateBegin, dateEnd, openingHoursStart, openingHoursEnd, isClosed }) => ({
    dateRange: dateBegin === dateEnd ? dateBegin : `${dateBegin} - ${dateEnd}`,
    time: isClosed
      ? null
      : `${dateHelper.stringifyMinutesCount(openingHoursStart)} - ${dateHelper.stringifyMinutesCount(openingHoursEnd)}`,
    isClosed: Boolean(isClosed),
  }));
